import React from 'react';
import {Modal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';

const UnarchiveCycleModal = ({uiState, modalOpen}) => {
  return (
    <Modal
      title='performance.Unarchive Check-In Cycle'
      size='sm'
      isOpen={modalOpen}
      onHide={() => uiState.closeUnarchiveCycleModal()}
    >
      <div className='mb3 jumbo'>
        <FormattedMessage id='performance.Past check-ins for this cycle will be actionable again, and the schedule for new check-ins will resume.'/>
      </div>
      <ModalButtons
        saveCaption='performance.Unarchive'
        onSave={() => uiState.unarchiveCycle()}
        onCancel={() => uiState.closeUnarchiveCycleModal()}/>
    </Modal>
  );
};

export default UnarchiveCycleModal;
